import React from 'react';

/**
 * RetailCliQ branded logo — uses the official /retailcliq-logo.png asset.
 * Falls back to the SVG vector mark if the PNG fails to load.
 * size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
 * showTagline: show tagline text below the logo
 * invertText: not needed for image mode (kept for API compat)
 */
export default function RetailCliqLogo({ size = 'md', showTagline = false, className = '' }) {
  // Logo image height per size
  const heights = { xs: 28, sm: 36, md: 48, lg: 64, xl: 84 };
  const taglineSizes = { xs: '9px', sm: '10px', md: '11px', lg: '12px', xl: '13px' };
  const h = heights[size] || heights.md;

  return (
    <div
      className={`flex flex-col items-start select-none ${className}`}
      aria-label="RetailCliQ"
    >
      <img
        src="/retailcliq-logo.png"
        alt="RetailCliQ"
        style={{ height: h, width: 'auto', display: 'block' }}
        draggable={false}
      />
      {showTagline && (
        <div
          className="text-muted-foreground"
          style={{
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: taglineSizes[size] || '11px',
            fontWeight: 500,
            letterSpacing: '0.07em',
            marginTop: '4px',
            textTransform: 'uppercase',
          }}
        >
          Smart Retail Solutions
        </div>
      )}
    </div>
  );
}
